<template>
  <div class="content-modal">
    <div class="header-modal">
      Daily Attendance Detail

      <div class="btn-close" @click.capture="closeClick">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M76.4168 123.583L123.583 76.4166M123.583 123.583L76.4168 76.4166M100 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1666 145.833 16.6666 100 16.6666C54.1668 16.6666 16.6667 54.1666 16.6667 100C16.6667 145.833 54.1668 183.333 100 183.333Z" stroke="white" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="form-modal">
      <div class="detail-container">
        <div class="header-detail">
          <p :class="[dataDetail.status === 'Hadir' && dataDetail.ket_hri !== 'Sunday'  ? 'text-success' : '', dataDetail.status === 'Izin' || dataDetail.status === 'Sakit' && dataDetail.ket_hri !== 'Sunday'  ? 'text-primary' : '', dataDetail.status === 'Alpa' && dataDetail.ket_hri !== 'Sunday'  ? 'text-danger' : '', dataDetail.ket_hri === 'Sunday'  ? 'text-disable' : '']">
            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dataDetail.status === 'Hadir' && dataDetail.ket_hri !== 'Sunday'">
              <path d="M99.9998 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 99.9998 16.6667C54.1665 16.6667 16.6665 54.1667 16.6665 100C16.6665 145.833 54.1665 183.333 99.9998 183.333Z" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M64.5835 100L88.1668 123.583L135.417 76.4167" stroke="#68B984" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dataDetail.status === 'Alpa' && dataDetail.ket_hri !== 'Sunday'">
              <path d="M76.4165 123.583L123.583 76.4167M123.583 123.583L76.4165 76.4167M99.9998 183.333C145.833 183.333 183.333 145.833 183.333 100C183.333 54.1667 145.833 16.6667 99.9998 16.6667C54.1665 16.6667 16.6665 54.1667 16.6665 100C16.6665 145.833 54.1665 183.333 99.9998 183.333Z" stroke="#E35D5B" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dataDetail.status === 'Izin' && dataDetail.ket_hri !== 'Sunday' || dataDetail.status === 'Sakit' && dataDetail.ket_hri !== 'Sunday'">
              <path d="M183.333 83.3333V125C183.333 166.667 166.667 183.333 125 183.333H75.0001C33.3334 183.333 16.6667 166.667 16.6667 125V75C16.6667 33.3333 33.3334 16.6667 75.0001 16.6667H116.667" stroke="#43A5FF" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M58.3333 108.333H108.333M58.3333 141.667H91.6666M183.333 83.3333H150C125 83.3333 116.667 75 116.667 50V16.6667L183.333 83.3333Z" stroke="#43A5FF" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dataDetail.ket_hri === 'Sunday'">
              <path d="M66.6668 16.6667V41.6667M133.333 16.6667V41.6667M29.1667 75.75H170.833M158.917 167.583L141.25 150M158.75 150.167L141.083 167.833M150 191.667C158.841 191.667 167.319 188.155 173.57 181.904C179.822 175.652 183.333 167.174 183.333 158.333C183.333 149.493 179.822 141.014 173.57 134.763C167.319 128.512 158.841 125 150 125C141.16 125 132.681 128.512 126.43 134.763C120.179 141.014 116.667 149.493 116.667 158.333C116.667 167.174 120.179 175.652 126.43 181.904C132.681 188.155 141.16 191.667 150 191.667Z" stroke="#4B4B4B" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M175 70.8334V136.333C168.917 129.417 160 125 150 125C131.583 125 116.667 139.917 116.667 158.333C116.667 164.583 118.417 170.5 121.5 175.5C123.25 178.5 125.5 181.167 128.083 183.333H66.6667C37.5 183.333 25 166.667 25 141.667V70.8334C25 45.8334 37.5 29.1667 66.6667 29.1667H133.333C162.5 29.1667 175 45.8334 175 70.8334Z" stroke="#4B4B4B" stroke-width="14.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M99.9584 114.167H100.042M69.1167 114.167H69.2M69.1167 139.167H69.2" stroke="#4B4B4B" stroke-width="14.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span v-if="dataDetail.status === 'Hadir' && dataDetail.ket_hri !== 'Sunday'">Present</span>
            <span v-if="dataDetail.status === 'Izin' && dataDetail.ket_hri !== 'Sunday'">Permission</span>
            <span v-if="dataDetail.status === 'Sakit' && dataDetail.ket_hri !== 'Sunday'">Sick</span>
            <span v-if="dataDetail.status === 'Alpa' && dataDetail.ket_hri !== 'Sunday'">Absent</span>
            <span v-if="dataDetail.ket_hri === 'Sunday'">Off Day</span>
          </p>
          <p></p>
          <p></p>
        </div>

        <div class="content-detail" v-if="!dataDetail.is_special">
          <p class="title-detail">{{ formatDay(dataDetail.date) }}</p>
          <p class="title-detail">{{ formatDate(dataDetail.date) }}</p>
        </div>
        <div class="content-detail" v-else-if="dataDetail.is_special">
          <p class="title-detail">{{ dataDetail.ket }}</p>
          <p class="title-detail">{{ dataDetail.date }}</p>
        </div>

        <!-- Profile data -->
        <div class="content-detail">
          <table>
            <tr>
              <td>NIS</td>
              <td>:</td>
              <td>{{ dataDetail.nis }}</td>
            </tr>
            <tr>
              <td>Name</td>
              <td>:</td>
              <td>{{ dataDetail.name_siswa }}</td>
            </tr>
            <tr>
              <td>Department</td>
              <td>:</td>
              <td>{{ dataDetail.name_department }}</td>
            </tr>
            <tr>
              <td>Class</td>
              <td>:</td>
              <td>{{ dataDetail.name_class }}</td>
            </tr>
            <tr>
              <td>School Time</td>
              <td>:</td>
              <td>{{ dataDetail.start_school }} {{ dataDetail.end_school != '' ? '- '+dataDetail.end_school : '' }}</td>
            </tr>
            <tr>
              <td>Timestamp</td>
              <td>:</td>
              <td>{{ dataDetail.jam }} {{ dataDetail.jam_akhir != '' ? '- '+dataDetail.jam_akhir : '' }}</td>
            </tr>
          </table>
        </div>

        <!-- Subject data -->
        <div class="content-detail sub-detail">
          <table>
            <tr v-for="(data, index) in dataDetail.semua_pelajaran" :key="data">
              <td>{{ index+1 }}.</td>
              <td>{{ data.subject }}</td>
              <td class="interger-value">{{ data.time1 }} - {{ data.time2 }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUpdated, watchEffect } from 'vue';
  import dayjs from 'dayjs';

  export default {
    name: "Modal Detail",
    props: {
      propDetail: {
        type: Object,
        default: () => ({ empty: true }),
      },
    },
    emits: ["close-modal"],
    methods: {
      formatDate(dateString) {
        const date = dayjs(dateString);
        return date.format('D MMMM YYYY');
      },

      formatDay(dateString) {
        const date = dayjs(dateString);
        return date.format('dddd');
      },

      formatIdr: value => (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    setup(props, { emit }) {
      const dataDetail = reactive({
        nis: '',
        name_siswa: '',
        name_class: '',
        name_department: '',
        date: '',
        thn: '',
        bln: '',
        hri: '',
        ket: '',
        ket_hri: '',
        status: '',
        semua_pelajaran: '',
        jam: '',
        is_special: false
      });

      const closeClick = (event, item) => {
        emit("close-click", event, item)
      }

      watchEffect(() => {
        const newdetail = props.propDetail;
        Object.assign(dataDetail, newdetail);
      });

      return {
        dataDetail,
        closeClick
      }
    }
  }
</script>
